import type { AxiosError, AxiosInstance } from 'axios';
import { SeverityLevel, trackException } from './appInsights';

/**
 * Attaches an axios response interceptor that reports every non-2xx response
 * (and network failure) as an Application Insights exception. Successful
 * requests continue to be captured by the SDK's built-in AJAX dependency
 * tracking, so this only supplements failure telemetry.
 */
export const registerAxiosTelemetry = (instance: AxiosInstance): void => {
	instance.interceptors.response.use(
		(response) => response,
		(error: AxiosError) => {
			const status = error.response?.status;
			const url = error.config?.url;
			const method = error.config?.method?.toUpperCase();

			trackException(
				{
					exception: error instanceof Error ? error : new Error(String(error)),
					severityLevel: status && status < 500 ? SeverityLevel.Warning : SeverityLevel.Error,
				},
				{
					url,
					method,
					status,
					code: error.code,
				},
			);
			return Promise.reject(error);
		},
	);
};
